import { H2RInput, H2RSelect } from "../../imports";
import OpenExternal from "../helpers/OpenExternal";
import { msToStringFormatted, stringToMS } from "../helpers/time";
import { replaceWithDataSource } from "../helpers/variable";
import TimeCountup from "../output/TimeCountup";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RSelect
				selected={cue.shape || "circle"}
				label="Shape"
				options={[
					{ label: "Circle", value: "circle" },
					{ label: "Line", value: "line" },
					{ label: "Mask", value: "mask" },
				]}
				onChange={(value) => {
					onUpdate({ shape: value });
				}}
			/>
			<H2RInput
				label="Display format (Large text)"
				value={cue.format}
				placeholder="HH:mm:ss"
				onChange={(value) => {
					onUpdate({ format: value });
				}}
			/>

			<OpenExternal
				buttonText={"More formatting options"}
				isElectronLink={`https://docs.h2r.graphics/graphics/time#display-format`}
				isNotElectronLink={`https://docs.h2r.graphics/graphics/time#display-format`}
			/>

			<H2RInput
				label="Start at (HH:MM:SS)"
				value={msToStringFormatted(cue.startOffset, false)}
				placeholder="e.g. 00:01:00 = 1 minute"
				onChange={(value) => {
					onUpdate({ startOffset: value });
				}}
			/>

			<H2RInput
				label="Duration (HH:MM:SS)"
				value={msToStringFormatted(cue.duration, false)}
				placeholder="e.g. 00:01:00 = 1 minute"
				onChange={(value) => {
					onUpdate({ duration: stringToMS(value) });
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div
			className={`overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
						${twoLines ? "whitespace-normal" : "whitespace-nowrap"}
		`}
		>
			<span
				style={{ fontVariantNumeric: "tabular-nums" }}
				className="font-semibold inline-block"
			>
				<TimeCountup cue={cue} cuePreview={true} />
			</span>
			<span className="pl-2 text-xs text-gray-300">
				{replaceWithDataSource(cue.pre, dynamicText, dynamicLists, true) || ""}
			</span>
		</div>
	);
};
